import VendorProfileDropdown from "../../VendorProfileDropdown";

const styles = {
    header: 'text-3xl mb-0 vendor-header opacity-80',
};

const ProfileNavBar = ({ heading }) => {
    return (
        <div className="w-full h-[60px] mt-4 border-b-[1px] border-exploreSearchBorder">
            <div className="w-full h-[40px] flex flex-row justify-between items-center">
                <h3 className="1.5xl:text-[30px] text-[#505050] font-allroundgothic font-[700] mb-0">{heading}</h3>
                <VendorProfileDropdown />
            </div>
        </div>
    );
}

export default ProfileNavBar;